/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});



  	
	$(document).ready(function() {		
		phoenix.init();
	});
  
  $(window).load(function(){
  	phoenix.grid_height();
  });

	var phoenix = {
        phoenixTimeout: null,
		isSidebarAjaxClick: false,
		init: function() {			
			this.banner();
            this.header(); 
			//this.product_variant_title(); 
            this.tabify();  
			this.qty();           	
			this.product_slider();	
          	this.pro_thumb();
            
              this.wishlist();
                 
            this.newsletter();
            this.sidebar_toggle();
          	this.alert_css(); 
            this.lookbook_slider();
            this.animation();          	
            this.pre_loader(); 
            this.scrolltop();
            this.section_script();
          
		},

        section_script: function(){
          var sections = new theme.Sections();
          sections.register('slideshow-section', phoenix.slider);
          sections.register('collection-template', phoenix.collection);
          sections.register('product-template', phoenix.product);
          sections.register('search-template', phoenix.grid_height);
          sections.register('contact-map',phoenix.map);	
        },
      
      shop_name : function(){
        if($(window).width() <= 1024){
          var shop_name = $('header').data('shop');
          $('.mean-bar .header_logo a').html('<h3>'+ shop_name +'</h3>');
        }
        
      },
      
         map: function(container){
           var $container = this.$container = $(container);  
           var zoom_level = $container.attr('data-zoom_level');
           var scrollwheel = $container.attr('data-scrollwheel');

           if(scrollwheel == 'false'){

             var boolen_scroll = 0 ;

           }else{

             var boolen_scroll = 1 ;

           }

             var latlng = new google.maps.LatLng(0, 0);
             var myOptions = {
               zoom: parseInt(zoom_level),
               center: latlng,
               scrollwheel:boolen_scroll,
               scaleControl:boolen_scroll,
               disableDefaultUI: false,
               mapTypeId: google.maps.MapTypeId.ROADMAP
             };
             var map2 = new google.maps.Map(document.getElementById("map-canvas"), myOptions);

             var geocoder_map2 = new google.maps.Geocoder();
             var address =$container.attr('data-address');
             geocoder_map2.geocode( { 'address': address}, function(results, status) {
               if (status == google.maps.GeocoderStatus.OK) {
                 map2.setCenter(results[0].geometry.location);

                 var marker = new google.maps.Marker({
                   map: map2, 
                   position: map2.getCenter()
                 });

                 var contentString = $container.attr('data-address');
                 var infowindow = new google.maps.InfoWindow({
                   content: contentString
                 });



               } else {
                 alert("Geocode was not successful for the following reason: " + status);
               }
             });

      },
  
      
      	pre_loader : function(){

          $(window).on('load', function() { // makes sure the whole site is loaded 
            $('#status').fadeOut(); // will first fade out the loading animation 
            $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website. 
            $('body').delay(350).css({'overflow':'visible'});
            if($(window).width > 1024){
            	new WOW().init();
            }
         
          }) 

        },
      
      	collection: function(container){
          	var $container = this.$container = $(container);
      		phoenix.open_filtertab();
           if($container.attr('data-filter') == 'true'){
            phoenix.initSidebar();
             phoenix.sidebarParams(); 
           }
          if($container.attr('data-sort_by') == 'true'){
            phoenix.sidebarMapSorting();
            phoenix.sidebarParams();
          }
           
            phoenix.grid_height();
          	phoenix.sidebar_toggle();
          
		},
      	
      	product: function(container){
          	var $container = this.$container = $(container);
          	var sectionId = $container.attr('data-section-id');
           if($container.attr('data-tab') == 'true'){
            $( "#product_tabs" ).tabs();
           }
            phoenix.grid_height();
            phoenix.product_slider();
            phoenix.pro_thumb();
           
          var sectionId = $container.attr('data-section-id');
        if (!$('#ProductJson-' + sectionId).html()) {
          return;
        }
        var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
        new Shopify.OptionSelectors('productSelect', {
          product: productSingleObject,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });

          var option_name = productSingleObject.options[0];


          // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
          if (productSingleObject.options.length == 1 && productSingleObject.options[0] != 'Title') {
            $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">'+ option_name +'</label>');
          }

          // Hide selectors if we only have 1 variant and its title contains 'Default'.
          if (productSingleObject.variants.length == 1 && productSingleObject.variants[0].title.toLowerCase().indexOf('default') !== -1) {
            $('.selector-wrapper').hide();
          }

          jQuery(function() {
            jQuery('.swatch :radio').change(function() {
              var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
              var optionValue = jQuery(this).val();
              jQuery(this)
              .closest('form')
              .find('.single-option-selector')
              .eq(optionIndex)
              .val(optionValue)
              .trigger('change');
            });
          });

          $('.swatch').each(function() {
            var index = $(this).data('option-index');
            $('.selector-wrapper:eq('+index+')').hide();
          });
		
          
            $("#AddToCart").click(function(e){
            var form = $(this).closest('form');
            phoenix.quickviewAjaxAddToCart(form);
            e.preventDefault();
          });
         
          
        },
      
      quickviewAjaxAddToCart:function(form){
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: jQuery(form).serialize(),
          dataType: 'json',
          beforeSend: function() {
           
          },
          success: function(msg) { 
           	  phoenix.quickviewUpdateCart();
             },
             error: function(xhr, text) {
              $(form).find("#AddToCart").val("Add to Cart");
              var data = eval('(' + xhr.responseText + ')');
              $('.product_info #AddToCartForm').next().after('<div class="errors qty-error">'+ data.description +'</div>');

              window.setTimeout(function() {
                $(".errors.qty-error").fadeOut();
              }, 2000);
            }
          });
        },

      quickviewUpdateCart:function(){
          	jQuery.getJSON('/cart.js', function (cart, textStatus) {
                $("#CartCount").show(); 
              	$("#CartCount").html(cart.item_count).removeClass('hidden-count');
               $('#CartCount')[0].click();
            });      
        
        },
		banner: function() {
			
            //==========================   SLIDER RESIZE HEIGHT
            $(window).load(function(){
                phoenix.resizeContent();                                       
            });
            $(window).resize(function() {
                phoenix.resizeContent();   
            });

		},

      	slider: function(container) {
          var $container = this.$container = $(container);
    	  var id = $container.attr('data-section-id');
          var transition = $container.attr('data-transition');
          if($container.attr('data-autoplay') == 'true'){
            var autoplay = true;
          }
          else{
            var autoplay = false;
          }
            
          var speed = $container.attr('data-speed');
          
          if($container.attr('data-show-dots') == 'true'){
            var show_dots = true;
          }
          else{
            var show_dots = false;
          }         
          
          if(transition == 'horizontal'){
          	var Loop_new = false;
		  }
          else{
          	var Loop_new = true;
          }
          //=============== SLIDER    =======          
          $('.bxslider').bxSlider({
            mode: $container.attr('data-transition'),
            captions: true,
            auto:autoplay,
            controls: false,
            pager: show_dots,
            pause: $container.attr('data-speed'),
            infiniteLoop: Loop_new,
            onSliderLoad: function () {
              $('.bxslider > li').not('.bxslider > li.bx-clone').eq(0).addClass('active-slide');
            },
            onSlideAfter: function (currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
              $('.bxslider > li.active-slide').removeClass('active-slide');
              $('.bxslider > li').not('.bxslider > li.bx-clone').eq(currentSlideHtmlObject).addClass('active-slide'); 
            }
          });
			
          	
		},
      
        resizeContent: function() {
            height_screen = $(window).height();
            product_slider_height = height_screen - 190;
            product_info_height = height_screen - 60;
            menu_height = height_screen - 55;
           // $('#banner_slider ul li , #banner_slider .bx-viewport, .banner_height').height(height_screen);
            $('.product_slider li , .main_product .bx-viewport').height(product_slider_height);
            $('#product_details .product_info').height(product_info_height);
            $('.mean-container .mean-bar .mean-nav > ul').css({"overflow-y": "scroll", "max-height": menu_height});            
            $('#banner_404, #banner_404 > div').height(height_screen);
            $('.shop_filter').css({"max-height": height_screen});  
          
        },

        header: function() {
            //================ RESPONSIVE MENU TRIGGER          
            $('header nav').meanmenu();         
                        
            // ================================== FOR STICKY NAV            
            var s = $("#header");
            var pos = s.position();                    
            $(window).scroll(function() {
                var windowpos = $(window).scrollTop();
                if (windowpos >= pos.top) {
                    $('#header').addClass('sticky_nav');
                } else {
                     $('#header').removeClass('sticky_nav')
                }
            }); 
            
            //open cart drawer
            $(".cart_icon").click(function(){
                $('.mini-cart').addClass('mini-cart-open');             
            }); 
            
            //close cart drawer
            $('.mini-cart-close').click(function() {
                $('.mini-cart').removeClass('mini-cart-open');  
            });   
          	$('#CartDrawer').click(function(e) {
              e.stopPropagation();
            });
            $('html').click(function() {
              $('.mini-cart').removeClass('mini-cart-open');  
            });
          
            /*$('.mini-cart-body,.mini-cart').click(function(event){
                event.stopPropagation();
            });*/

            //====  BODY OVERFLOW            
            $("a.meanmenu-reveal").click(function(){
                $('body').toggleClass("main_overflow");
            });                     
            
          
          	//search leave close
            window_width = $(window).width();
            if(window_width < 1025){              
              $(".search-form").click(function(){
                $('.search_toggle').slideToggle('slow');
              }); 
            }
          
            else{
              $('.search-form').mouseleave(function(e) {
                var get_search_length = $('#q').val().length;
                if(get_search_length > 0){
                  $('input',this).css('width','200px');
                }
                else{
                  $('input',this).attr('style','');
                  $('.search-form input').blur(function(e) {
                    $(this).attr('style','');
                    $(this).attr('style','');
                  });
                }
              });

              $('.search-form').click(function(e){
                e.stopPropagation();
              });
              $('html').click(function(){
                $('.search-form input').attr('style','');
              });
            }
          	
        },

        newsletter: function() {
            //===   NEASLETTER POPUP
            $(window).load(function(){
                setTimeout( function() {
                  var check_cookie = $.cookie('mailing_list_popup');
                  
                  $('.newsletter_popup .close_btn').click(function(e) {
                    $.cookie('mailing_list_popup', '1', { expires: 31 });
                    $(".newsletter_overlay").removeClass('newsletter_popupactive');
                    $('body').removeClass('overflow_hidden');
                  });
                  
                  if(check_cookie == null){
                    $.cookie('mailing_list_popup', '1', { expires: 31 });
                    $(".newsletter_overlay").addClass('newsletter_popupactive');
                    $('body').addClass('overflow_hidden');
                  }
                  else if(check_cookie < 1){
                    x = $.cookie('mailing_list_popup');
                    y = 1;
                    var z = +x + +y;
                    $.cookie('mailing_list_popup', z, { expires: 31 });
                      $(".newsletter_overlay").addClass('newsletter_popupactive');
                      $('body').addClass('overflow_hidden');
                  }
                }, 3000);
            }); 
        },
		
		product_variant_title: function() {
			$("#AddToCartForm .selector-wrapper").each(function(index,element){
		      var label_name = $(this).find("label").text();
		      label_name = label_name.toUpperCase();
		      $(this).find("label").hide();
		      $("<option value='' selected>"+label_name+"</option>").prependTo($(this).find("select"));
		    });
		},

        tabify: function(){                
            
          	// accordation for faqs page
            $(function() {
              $("#accord").accordion({
                collapsible: true,
                heightStyle: "content"
              });
            });
          
        },

		qty: function(){
			// --------------- Cart page -----------------
			$(".cart-items .cart-item .product_qty .plus").each(function(index,element){
				$(this).click(function(){
					var getval = $(this).parent().find("#quantity").val();
					getval++;
			  		$(this).parent().find("#quantity").val(getval);
			  		$("#update-cart").trigger('click');
				});
			});
			$(".cart-items .cart-item .product_qty .minus").each(function(index,element){
				$(this).click(function(){
					var getval = $(this).parent().find("#quantity").val();
					if(getval != 1){
					  getval--;
					  $(this).parent().find("#quantity").val(getval);
					  $("#update-cart").trigger('click');
					}
				});
			});
		},

      	grid_height: function(){	
           //============================== PRODUCT LIST IMG HEIGHT                    
           $('.product_list .product_item .product_img').responsiveEqualHeightGrid(); 
           $('.search_blog_list .blog_item .blog_img').responsiveEqualHeightGrid(); 
           /*$('.collections_list .product_list').each(function(index,element){
             $('.grid__item',this).each(function(index,element){
               	$('.product_item .product_img',this).responsiveEqualHeightGrid(); 
             });
           });*/
           $('.collections_list .product_list').each(function(index,element){
             $('.owl-stage .owl-item',this).each(function(index,element){
               	$('.product_item .product_img',this).responsiveEqualHeightGrid(); 
             });
           });
		}, 
      
		open_filtertab: function(){
			//============== Filter			
			$('.shop_filter .tag-filter h6').each(function(index, element) {
				$(this).click(function(e) {   
					$(this).parent().siblings().find('ul').slideUp('fast');
					$(this).parent().find('ul').slideToggle('fast');
				});
			});
          	$('html').click(function() {				
				$('.sidebar-tag').slideUp('fast');
			});
            $(".shop_filter .tag-filter h6, .sidebar-tag").click(function(e){
				e.stopPropagation();
            });
		},			
		
        lookbook_slider: function() {
			$('#look_slider').fullpage({
                'verticalCentered': false,
                'css3': true,
                'navigation': true,
                'navigationPosition': 'right',				
            });
        },
      
		product_slider: function(){
            
 			$('#thumb-pager').owlCarousel({
                loop:true,
                nav:true,
              	dots:false,
                responsive:{
                    0:{
                      items:4
                    },
                    481:{
                      items:5
                    },
                    768:{
                      items:6
                    },
                    993:{
                      items:7,
                    },
                    1024:{
                      items:7,
                    },
                    1025:{
                      items:7,
                    }
                }
            })
               
                  
            $('#related_product .product_list > .grid, .collections_list .product_list > .grid').owlCarousel({
                loop:false,
                nav:true,
                dots:true,
                margin:30,
                responsive:{
                    0:{
                      items:1,
                      margin:0,
                    },
                    481:{
                      items:2,
                      margin:10,                                                                                          
                    },
                  	767:{
                      items:2,
                      margin:10,
                    },
                    768:{
                      items:3,
                      margin:15,
                    },
                  	991:{
                      items:3,
                      margin:20,
                    },
                    992:{
                      items:4,
                      loop:false,
                      margin:20,
                    },
                    1024:{
                      items:4,
                      loop:false,
                      margin:20,
                    },
                    1025:{
                      items:5,
                      loop:false,
                	  dots:false
                    }
                }
            })
          
		},

        zoom: function() {    
            //zoom on featured image 
           
        },
      
      	pro_thumb:function() {        
          $("#thumb-pager .owl-stage a img").click(function(){            
            var src_img = $(this).parent().data("img");
            $("#ProductPhotoImg").attr("src",src_img); 
            $("#thumb-pager a").removeClass("active");
            $(this).parent().addClass("active");
            
          }); 
          
           
          $("#thumb-pager a").each(function(index, element) {
            if($(this).data("img") == $("#ProductPhotoImg").attr('src')){
                $(this).addClass("active");
            }
          });
          
        },
      
      	wishlist: function() {    
            //============wishlist ajax
            $(".wishlist_btn").click(function(e) {
              e.preventDefault();
              var form = $(this).parent();
              $.ajax({
                url : '/contact#contact_form',
                type: "POST",
                data : form.serializeArray(),
                success:function(data, textStatus) {              
                  	alert("This product Added in your Wishlist"); 
                  	var product =form.find(".wishlist").html();                  
                    form.parent().empty().html('<div class="wishlist_added"><a href="/pages/wishlist" class="add-new-address wishlist"><span><i class="entypo-heart"></i></span> Added in your wishlist</a></div>');
                },
                error: function() {
                  $(this).append("<p>I'm afraid that didn't work.</p>");
                }
              });
            }); 
        },
      
		initSidebar: function() {    
            //if category page then init sidebar           
           if($(".shop_filter").length > 0){            
              phoenix.getCurrentTag();            
              phoenix.sidebarMapClear();
              phoenix.sidebarMapClearAll();
            }
            phoenix.sidebarMapPaging();
            phoenix.sidebarMapEvents();
        },

        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
      
        //==========================   SIDEBAR TOGGLE 		
        sidebar_toggle: function(){
          $(".mobile_filter .filter--toggle").click(function(e) {
            $('.shop_filter').addClass('side_toggle');
            $('body').addClass('body_blur');
          });
          $(".back_clear .back_arrow").click(function(e) {
            $('.shop_filter').removeClass('side_toggle');
            $('body').removeClass('body_blur');
          });			
        },

        sidebarMapEvents: function() {
            phoenix.sidebarMapTagEvents();
           
        },

        sidebarMapTagEvents: function() {            
            $('.sidebar-tag a:not(".clear"), .sidebar-tag li').click(function(e) {
                var currentTags = [];
                var check_radio =  $(this).find("input").attr("type");
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }
                if(check_radio == "radio"){                 
                //one selection or multi selection                
                    if (!window.enable_sidebar_multiple_choice && !$(this).find("input").is(":checked")) {
                        //remove other selection first
                        var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                        if (otherTag.length > 0) {
                            var tagName = otherTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        }
                    }
                }

                var tagName = $(this).find("input").val();                
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);                    
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                phoenix.sidebarAjaxClick();
                e.preventDefault();
            });
        },
      
      	getCurrentTag: function() {
          	$(".tag_list").empty();
            //$(".tag_list").append(' <label>Filter By: </label>' );
          	$(".shop_filter .tag-filter ul").each(function(index, element){              
               $('li',this).each(function(index, element) {                 
				  $("input:checked", this).each(function(index, element) {
                 	var current_tag_val = $(this).val();   
                    var current_tag_name = $(this).next().text();
                	$(".tag_list").append("<span value='"+ current_tag_val +"'>"+ current_tag_name +"</span>" );
                  });
               });               
            });
            $(".tag_list").append(' <span class="clear-all"> Clear All </span>' );
          
            $(".tag_list span , .apply_filter").click(function(e) {  
             	var currentTags = [];
               	var remove_tag = $(this).attr("value");
                $(".shop_filter .tag-filter ul").each(function(index, element){              
                  $('li',this).each(function(index, element) {                 
                    $("input:checked", this).each(function(index, element) {
                      var current_tag_val = $(this).val();

                      if(current_tag_val == remove_tag ){

                      }else{
                        currentTags.push($(this).val()); 
                      }
                    });
                  });                
                }); 
                if (currentTags.length) {
                  $(".filter_tag").show();
                  Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                  $(".filter_tag").hide();
                  delete Shopify.queryParams.constraint;
                }

                if($(this).hasClass('apply_filter')){
                  $(".filter-icon.active").trigger('click');
                }

              phoenix.sidebarAjaxClick(); 
              e.preventDefault();
            });          
        },
      
        sidebarMapSorting: function(e) {  
            $("#heapbox_SortBy .heapOptions a").click(function(){           
              Shopify.queryParams.sort_by = $(this).attr("rel"); 
              phoenix.sidebarAjaxClick();
            });                 
        },

        sidebarMapPaging: function() {
            $(".collection-filter .pagination a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if(page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = phoenix.sidebarCreateUrl();
                        phoenix.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        phoenix.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            'scrollTop': 0
                        }, 500);
                    }
                }
                e.preventDefault();
            });
        },
        
        sidebarMapClearAll: function() {
            //clear all selection
             $('.tag_list .clear-all,.back_clear .clear-all').click(function(e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;                
              	phoenix.sidebarAjaxClick();
               	$(".tag_list").empty();
                e.preventDefault();                
            });
        },

        sidebarMapClear: function() {            
            $(".sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if(sidebarTag.find("input:checked").length > 0) {
                    $('.tag_list .clear-all').show();
                    //has active tag
                    sidebarTag.find(".clear").css("display","block").click(function(e) {
                        var currentTags = [];
                        if(Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if(tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if(currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
                        phoenix.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        },

        sidebarCreateUrl: function(baseLink) {
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            
            if (newQuery != "")
              return location.pathname + "?" + newQuery;
            else
              return location.pathname + newQuery; 
        },

        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = phoenix.sidebarCreateUrl(baseLink);            
            phoenix.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            phoenix.sidebarGetContent(newurl);            
        },

        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    phoenix.showLoading();
                },
                success: function(data) {
                    phoenix.sidebarMapData(data);   
                  	if($(".shop_filter").length > 0){ 
                      phoenix.getCurrentTag();
                      phoenix.sidebarMapClear();
                      phoenix.sidebarMapClearAll();
                    }
                    phoenix.sidebarMapPaging();
                  	//phoenix.translateBlock("#collection_list");
                    phoenix.sidebarMapTagEvents();                    
                   
                  	phoenix.sidebar_toggle();
                    setTimeout(function() {
                  	   phoenix.grid_height();
                       phoenix.hideLoading();  
                    }, 1000);                 
                },
                error: function(xhr, text) {
                    phoenix.hideLoading();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                }
            });
        },
      
		showLoading: function() {
            $('.loading-modal').show();
        },
      
      	hideLoading: function() {
            $('.loading-modal').hide();
        },
      
        animation :function(){
          if($(window).width > 1024){
            new WOW().init();
          }
        },
        
        scrolltop :function(){
          $('#scrollToTop').bind("click", function () {
            $('html, body').animate({ scrollTop: 0 }, 800);
            return false;
          });
        },
      
        sidebarMapData: function(data) {                       
            var currentList = $(".product_list > .grid");
            if (currentList.length == 0) {
                currentList = $(".product_list > .grid");
            }
            var productList = $(data).find(".product_list > .grid");

            if (productList.length == 0) {
                productList = $(data).find(".product_list > .grid");
            }
            currentList.replaceWith(productList);
           
            //replace paging 
            if ($(data).find(".pagination").length > 0) {
            	$(".pagination").show();
                $(".pagination").replaceWith($(data).find(".pagination"));
            }else{
            	$(".pagination").hide();
            }

            //replace tags            
            $(".shop_filter").replaceWith($(data).find(".shop_filter"));       

          	
          	 $('body').removeClass('body_blur');
            //open filter tab     
            phoenix.open_filtertab();
          	
        },
      
      	translateBlock: function(blockSelector) {
          if (window.multi_lang && translator.isLang2()) {
            translator.doTranslate(blockSelector);
          }
        },
      	alert_css: function(){
          //------ alert css -----------
			window.alert = function(message) { $('#messageBox').text(message).fadeIn().delay(4000).fadeOut('slow'); }
        },

    }

			
//==========================   QUANTITY SELECT			
function plus(){
	var getval = $('#quantity').val();
	getval++;
	$('#quantity').val(getval);
	
};
function minus(){
	var getval = $('#quantity').val();
	if(getval > 1)
	{
	getval--;
	}
	$('#quantity').val(getval);
}; 
				
$(".sort_by").heapbox();

function isMobileFunc() { 
  var userAgent = navigator.userAgent.toLowerCase();   
  var phone = (/iphone|android|ipod|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(userAgent));
  var tablet = (/sch-i800|playbook|tablet|kindle|gt-p1000|sgh-t849|shw-m180s|a510|a511|a100|dell streak|silk/i.test(userAgent));
  return phone || tablet;
}
var enable_lazy_loading_pc = true;
var enable_lazy_loading_mobile = false;
var isMobile = isMobileFunc();

if ((enable_lazy_loading_pc && !isMobile) || (enable_lazy_loading_mobile && isMobile)) {
  if($(window).width() > 1024 ){ 	
  	new WOW().init({offset:50});
  	}
  }
